export default __webpack_public_path__ + "static/media/Premier Paver 1.6 ratio.a38a701c.jpg";